import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import moment from 'moment';
const getImportFeeValue = (metrics = {}) => {
  const value = metrics?.importFee
    ?? metrics?.importFees
    ?? metrics?.totalImportFee
    ?? metrics?.totalImportFees
    ?? metrics?.importFeeAmount
    ?? metrics?.importFeesAmount
    ?? metrics?.importFeeTotal
    ?? metrics?.importFeesTotal
    ?? metrics?.totalValueImportFee
    ?? metrics?.totalImportTax
    ?? metrics?.importTax
    ?? metrics?.importedFee
    ?? metrics?.importedFees
    ?? metrics?.euImportFee
    ?? metrics?.euImportFees
    ?? metrics?.totalEuImportFee
    ?? metrics?.totalEuImportFees;

  return Number(value) || 0;
};

export default {
  namespaced: true,
  state: {
    perProductInfo: {},
    perMultiData: {},
    bundleData: {},

  },
  getters: {
  },
  mutations: {
    setCalculationData(state, data) {
      state.perProductInfo = data;
    },
    setBundleData(state, data) {
      state.bundleData = data;
    },
    setMultiData(state, data) {
      state.perMultiData = data;
    },
    updateSingleMarketing(state, obj) {
      var previous = state.perProductInfo.perProductInfo[obj.id].marketing;
      var profitchange = previous - obj.data;
      state.perProductInfo.perProductInfo[obj.id].marketing = obj.data
      state.perProductInfo.perProductInfo[obj.id].profit += profitchange
    },
    // … inside mutations: { … }

    mergeLiveData(state, payload) {
      const liveData = payload?.liveData ?? payload ?? {};
      const importFeeEnabled = payload?.importFeeEnabled === true;
      const historic = state.perProductInfo;
      if (!historic?.perProductInfo?.products) return;

      const products = historic.perProductInfo.products;

      // all the keys your store tracks per product
      const allKeys = {
        automatedMarketing: 0,
        facebookProductMarketing: 0,
        googleProductMarketing: 0,
        pinterestProductMarketing: 0,
        snapchatProductMarketing: 0,
        orders: 0,
        paymentFee: 0,
        productCost: 0,
        importFee: 0,
        profit: 0,
        refunds: 0,
        totalAutmatedMarketing: 0,
        totalOrders: 0,
        totalSold: 0,
        totalSoldPrice: 0,
        totalVat: 0
      };

      // map live‑payload keys → your store's keys
      const keyMap = {
        marketing: 'automatedMarketing',
        fee: 'paymentFee',
        orders: 'totalOrders',
        productCost: 'productCost',
        refunds: 'refunds',
        totalSold: 'totalSold',
        totalSoldPrice: 'totalSoldPrice',
        totalVat: 'totalVat'
        // note: we’re handling profit manually below
      };

      Object.values(liveData).forEach(dayBlock => {
        const dayProducts = dayBlock.products || {};
        Object.entries(dayProducts).forEach(([id, metrics]) => {
          // if this product is new, seed it with zeroes
          if (!products[id]) {
            products[id] = { ...allKeys };
          }
          const target = products[id];

          // 1) calculate profit for this product/day
          const totalSales = Number(metrics.totalSoldPrice) || 0;
          const marketing = Number(metrics.marketing) || 0;
          const fee = Number(metrics.fee) || 0;
          const productCost = Number(metrics.productCost) || 0;
          const importFee = importFeeEnabled ? getImportFeeValue(metrics) : 0;
          const refunds = Number(metrics.refunds) || 0;
          const providedProfit = metrics?.profit ?? metrics?.totalProfit;
          const profitVal = providedProfit != null ? (Number(providedProfit) || 0) : totalSales - marketing - fee - productCost - importFee - refunds;

          // 2) merge all the standard metrics
          for (const [liveKey, storeKey] of Object.entries(keyMap)) {
            const liveVal = Number(metrics[liveKey] || 0);
            target[storeKey] = (Number(target[storeKey]) || 0) + liveVal;
          }
          target.importFee = (Number(target.importFee) || 0) + importFee;

          // 3) merge the freshly computed profit
          target.profit = (Number(target.profit) || 0) + profitVal;
        });
      });

      console.log("state.perProductInfo", state.perProductInfo);
    },



  },
  actions: {
    CalculateOrderProductCombinations({ commit, dispatch, rootState }, data) {
      const fromDate = moment(data.from).format(); // Use your desired format here
      const toDate = moment(data.to).endOf('day').format(); // Use your desired format here


      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-PerformCalculationsV2', body: {
            from: fromDate,
            to: toDate,
            ...(rootState?.userdata?.whopShopName && rootState.userdata.whopShopName === firebase.auth().currentUser?.uid
              && (rootState.userdata.whop === true || rootState.userdata.whopHasHistory === true)
              ? { includeWhop: true } : {}),
          }
        }, { root: true }).then(x => {
          commit("setCalculationData", x.data)

          dispatch("shopify/FetchAnalyticsProductName", [], { root: true }).then(b => {


            const producNamesFetched = b

            if (!producNamesFetched) {

              try {
                const keysArray = Object.keys(x.data?.perProductInfo?.products);
                if (keysArray) {
                  console.log("keyyyy", keysArray)
                  dispatch("shopify/FetchTargetedProductsFromDatabase", keysArray, { root: true });
                }
              } catch (e) {
                console.log("might be no products", e)
              }
            }

          });


          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    /**
     * Fetch live product analytics for date ranges that include today.
     * Server-side should merge historical + live data.
     */
    CalculateLiveOrderProductCombinations({ commit, dispatch }, data) {
      const fromDate = moment(data.from).format();
      const toDate = moment(data.to).endOf('day').format();
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/liveTrackingProduct-GetLiveDataProductAnalytics', body: {
            from: fromDate,
            to: toDate
          }
        }, { root: true }).then(x => {
          // overwrite calculation data with live-merged results
          console.log("live Data", x.data)


          resolve(x.data)
        }).catch(error => {
          reject(error)
        });
      });
    },

    MergeLiveDataProductAnalytics({ state, commit, dispatch, rootState }, liveData) {
      // merge liveData into state.perProductInfo
      commit('mergeLiveData', {
        liveData,
        importFeeEnabled: rootState.userdata.importFeeEnabled === true,
      });
      commit('setCalculationData', state.perProductInfo)
      // return the updated object if you need to chain .then(…)
      try {

        dispatch("shopify/FetchAnalyticsProductName", [], { root: true }).then(b => {


          const producNamesFetched = b

          console.log("Product Name fetch ", producNamesFetched)
          if (!producNamesFetched) {

            try {
              const keysArray = Object.keys(state.perProductInfo?.perProductInfo?.products);

              if (keysArray) {
                console.log("keyyyy", keysArray)
                dispatch("shopify/FetchTargetedProductsFromDatabase", keysArray, { root: true });
              }
            } catch (e) {
              console.log("might be no products", e)
            }
          }

        });

      } catch (e) {
        console.log("might be no products", e)
      }



      return state.perProductInfo;
    },

    CalculateBundles({ commit, dispatch }, data) {
      const fromDate = moment(data.from).format(); // Use your desired format here
      const toDate = moment(data.to).endOf('day').format(); // Use your desired format here


      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/bundleAnalytics-PerformBundleCalculation', body: {
            from: fromDate,
            to: toDate
          }
        }, { root: true }).then(x => {

          commit("setBundleData", x.data)
          dispatch("shopify/FetchAnalyticsProductName", [], { root: true }).then(b => {


            const producNamesFetched = b

            console.log("Product Name fetch ", producNamesFetched)
            if (!producNamesFetched) {

              try {
                const keysArray = Object.keys(x.data?.perProductInfo?.products);
                if (keysArray) {
                  dispatch("shopify/FetchTargetedProductsFromDatabase", keysArray, { root: true });
                }
              } catch (e) {
                console.log("might be no products", e)
              }
            }

          });


          resolve("success")
        }).catch(error => {
          reject(error);
        });
      })
    },
    getAdvancedProducts({ commit, dispatch }, data) {
      const fromDate = moment(data.from).format(); // Use your desired format here
      const toDate = moment(data.to).endOf('day').format(); // Use your desired format here
      const filter = data?.filter ?? null

      console.log("advanced filter fetch")

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/advancedFiltering-fetchFilterData', body: {
            from: fromDate,
            to: toDate,
            filter: filter
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        })
      })
    },
    getDataforExport({ commit, dispatch, rootState }, data) {
      const fromDate = moment(data.from).format(); // Use your desired format here
      const toDate = moment(data.to).endOf('day').format(); // Use your desired format here


      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/shopify-PerformCalculationsV2', body: {
            from: fromDate,
            to: toDate,
            ...(rootState?.userdata?.whopShopName && rootState.userdata.whopShopName === firebase.auth().currentUser?.uid
              && (rootState.userdata.whop === true || rootState.userdata.whopHasHistory === true)
              ? { includeWhop: true } : {}),
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    CalculateMultiDashboard({ commit, dispatch }, data) {
      const fromDate = moment(data.from).format(); // Use your desired format here
      const toDate = moment(data.to).endOf('day').format(); // Use your desired format here
      const metaAccount = data.metaAccount


      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/multiStoreCalc-PerformMultiCalculations', body: {
            from: fromDate,
            to: toDate,
            metaAccount: metaAccount
          }
        }, { root: true }).then(x => {
          commit("setMultiData", x.data)

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },


    ComputeMarketingCostForProduct({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {

        dispatch('api/apiPostWithToken', {
          path: '/shopify-computeMarketingCostForProduct', body: {
            from: data.from,
            to: data.to,
            productMarketing: data.productMarketing
          }
        }, { root: true }).then(x => {

          var obj = { id: data.id, data: x.data }
          commit("updateSingleMarketing", obj)
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetAssignedAds({ commit, dispatch }, data) {

      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/generalMarketing-GetAssignedAds', body: {
            id: data.id,
            platform: data.platform
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },
    GetUnassignedAds({ commit, dispatch }, platform) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/generalMarketing-GetUnassignedAds', body: {
            platform: platform
          }
        }, { root: true }).then(x => {

          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    RemoveAssignedAds({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/generalMarketing-RemovingAssignedAds', body: {
            assigned: data.assigned,
            adId: data.adId,
            docId: data.docId,
            platform: data.platform
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },

    AssignRemovedAds({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/generalMarketing-AssignedRemovedAds', body: {
            assigned: data.assigned,
            adId: data.adId,
            docId: data.docId,
            productID: data.productID,
            platform: data.platform
          }
        }, { root: true }).then(x => {
          resolve(x.data)
        }).catch(error => {
          reject(error);
        });
      })
    },


    async createFirstFilter({ dispatch }, chargeID) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/advancedFiltering-createFirstFilterUltimate',
          body: { shopName: shopName }
        }, { root: true })
        resolve("success")
      })
    },


    createFilter({ dispatch }, filter) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/advancedFiltering-createNewFilter',
          body: { shopName: shopName, filter: filter }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },

    deleteFilter({ dispatch }, filter) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/advancedFiltering-deleteFilter',
          body: { shopName: shopName, filter: filter }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
    createnotification({ dispatch }, notification) {
      let shopName = firebase.auth().currentUser.uid
      return new Promise((resolve, reject) => {
        dispatch('api/apiPostWithToken', {
          path: '/liveTracking-createNotification',
          body: { shopName: shopName, notification: notification }
        }, { root: true }).then(x => {
          resolve(x)
        }).catch(error => {
          reject(error);
        });
      })
    },
  },
}
